import { Input, Output, EventEmitter, OnDestroy, Component } from '@angular/core';
import { SortDirection, Sort } from '@angular/material/sort';

import { SnListBaseComponent } from './list-base.component';

@Component({ template: '' })
export abstract class SnTableBaseComponent<Data>
  extends SnListBaseComponent<Data>
  implements OnDestroy
{
  @Input()
  public columns: string[] = [];

  @Input()
  public sort: string;

  @Input()
  public sortDirection: SortDirection;

  @Output()
  public readonly sortChange = new EventEmitter<Sort>();

  public ngOnDestroy(): void {
    super.ngOnDestroy();

    this.sortChange.complete();
  }

  public onSortChange(sort: Sort): void {
    this.sortChange.emit(sort);
  }
}
